const cache = new Map()

function checkImage(src) {
  if (cache.has(src)) return cache.get(src)

  const promise = new Promise((resolve) => {
    const img = new Image()
    img.onload = () => resolve(src)
    img.onerror = () => resolve(null)
    img.src = src
  })

  cache.set(src, promise)
  return promise
}

export default {
  async mounted(el, binding) {
    const sources = binding.value.filter(Boolean)

    const result = await Promise.any(
      sources.map(src =>
        checkImage(src).then(res => {
          if (!res) throw new Error()
          return res
        })
      )
    ).catch(() => null)

    if (result) {
      el.src = result
    }
  }
}
